import {CodeRecipe} from './CodeRecipe';
import './Docker.css';

export const Docker = () => {
	return (
		<>
			<CodeRecipe
				title='Frontend multistage build'
				fileLocation='/recipes/docker-frontend.txt'
			/>
			<CodeRecipe
				title='Backend multistage build'
				fileLocation='/recipes/docker-backend.txt'
			/>
			<CodeRecipe
				title='Deploy with helm'
				fileLocation='/recipes/docker-github-actions.txt'
			/>
		</>
	);
};
